export const css = {
	root: 'TJ48OO_i',
	close: '_2i_vQvie',
	indicator: '_2FkLCZkP',
	tabButtons: '_2D2eZYaZ',
	tabButton: '_3NOjlpjF',
	disabledTabButton: '_3omIp9Dy',
	activeTabButton: '_6lmitv5L',
	closeable: '_2epGFIRQ',
	tab: '_2ws0Na_s',
	alignLeft: '_2XIV6WTh',
	alignRight: '_2AdhQaxC',
	tabs: '_2JDArz-k',
	alignBottom: 'ac30dF9Z',
	indicatorActive: '_3wdplt52',
	indicatorContent: '_1kE8pZui',
	tabButtonContent: 'lSTBkhzy',
	' _key': 'ascm-theme/ascm/base-widgets/tab-container'
};

export default css;
